type UseCreateStrategyClient = () => any;

export const useCreateStrategyClient: UseCreateStrategyClient = () => {
  return {};
};
